import React from 'react'
import {ReadyState} from 'react-use-websocket'
import { t } from '../../i18n'
import { Bdi } from '../../i18n/direction'

function GushMenuBar({
                         connectionState = ReadyState.CLOSED,
                         playerName,
                         gameCode,
                         onLeave,
                         isLeaving = false,
                     }) {
    const offline = connectionState !== ReadyState.OPEN && connectionState !== ReadyState.CONNECTING
    return (
        <>
            <header className="hdr" style={offline ? { borderBottom: 0 } : undefined}>
                <span className="hdr-name"><Bdi>{playerName}</Bdi></span>
                <span className="code" aria-label={t('game.codeLabel', { code: gameCode })}>{gameCode}</span>
                {connectionState === ReadyState.OPEN
                    ? <span className="conn" role="img" aria-label={t('game.connected')}><span className="dot-ok"></span></span>
                    : connectionState === ReadyState.CONNECTING
                        ? <span className="conn" role="img" aria-label={t('game.connecting')}><span className="dot-wait"></span></span>
                        : <span className="conn" role="img" aria-label={t('game.offline')}><svg width="24" height="24" viewBox="0 0 24 24" fill="#ee5a4a" stroke="#24102a" strokeWidth="2" strokeLinejoin="round" aria-hidden="true"><path d="M12 3l10 18H2z"></path><path d="M12 10v5M12 18v.01" fill="none" strokeLinecap="round" strokeWidth="2.4"></path></svg></span>}
                <button className="icon-btn" aria-label={t('game.leave')} onClick={onLeave}
                    aria-expanded={isLeaving} style={isLeaving ? { background: '#ee5a4a', border: '2px solid #24102a' } : undefined}><svg className="icon-dir" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M10 4H5v16h5"></path><path d="M14 8l-4 4 4 4"></path><path d="M10 12h10"></path></svg></button>
            </header>
            {offline && <div className="offline-strip" aria-hidden="true"></div>}
        </>
    )
}

export default GushMenuBar
